// extracted by mini-css-extract-plugin
export default {"root":"CustomColumns_root__rYWn4","icon":"CustomColumns_icon__Ul63C"};